const PDF_MAGIC_BYTES = '%PDF';

export interface AssertPdfBlobOptions {
    /** Reject a blob smaller than this even if it starts with `%PDF` (a real rendered
     * document is always far bigger than any JSON error body). Omit to check magic bytes
     * only — appropriate for callers whose genuine PDF can legitimately be small, e.g. a
     * one-event consent audit trail. */
    minBytes?: number;
}

/** Throws when `blob` is not a plausible PDF. Never mutates or consumes the blob beyond
 * reading its own bytes, so callers may still hand the original blob to a download link
 * after this resolves. */
export async function assertPdfBlob(blob: Blob, { minBytes = 0 }: AssertPdfBlobOptions = {}): Promise<void> {
    const header = await blob.slice(0, PDF_MAGIC_BYTES.length).text();
    if (blob.size >= minBytes && header === PDF_MAGIC_BYTES) return;

    const snippet = await blob.text().catch(() => '<unreadable response body>');
    throw new Error(`response is not a valid PDF (${blob.size} bytes): ${snippet.slice(0, 500)}`);
}
